import React, { createContext, useContext, useState, useEffect } from 'react'
import { safeGetItem, USER } from '../../lib/storage'

const UserContext = createContext()

export const UserContextProvider = ({ children }) => {
  const [user, setUser] = useState(null)

  useEffect(() => {
    // Same crash class as FE-P1: localStorage.getItem can throw (Safari private mode /
    // restricted webviews) and JSON.parse can throw on a corrupt value. Guard both so a
    // bad/inaccessible stored user degrades to logged-out instead of an uncaught error.
    try {
      const raw = safeGetItem(USER)
      const storedUser = raw ? JSON.parse(raw) : null
      if (storedUser) {
        setUser(storedUser)
      }
    } catch (_) {
      // corrupt or unreadable stored user — leave as null
    }
  }, [])

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  )
}

export const useUser = () => {
  const context = useContext(UserContext)
  if (!context) {
    throw new Error('useUser must be used within a UserContextProvider')
  }
  return context
}

